import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { CitizenReport } from '../../model/citizen-report';
import { NetworkService } from '../../service/network.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaCitizenReportHttpService extends GenericAkitaHTTPService<CitizenReport> {

  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CitizenReport',
        options: 'keyValues',
        limit: '50',
        orderBy: '!dateCreated'
      }
    };
    super(http, networkService, '/v2/entities', 'citizenreport', options);
  }
}
